export default __webpack_public_path__ + "static/DSC_0455-9ac375678b9eb9b6eb0aa26cc9f45475.jpg";